module.exports = __webpack_public_path__ + "static/media/file_type_audio_error_icon.7cbde16a.svg";